import { Cookies } from 'react-cookie';
import { AnyAction, Store } from 'redux';
import './App.css';
import CookiesConsent from './components/cookiesConsent/CookiesConsent';
import AppRoutes from './components/routes/Routes';
import { ApplicationState } from './store/types';
import './styles/_styles.scss'
import { ThemeProvider } from '@emotion/react';
import theme from './components/theme/theme';

import { Provider } from 'react-redux';

import Lang from './components/lang/Lang';
import { Suspense } from 'react';
import { SnackbarProvider } from "notistack";
import AppLayout from './components/layouts/AppLayout';


interface Props {
  store: Store<ApplicationState, AnyAction>,
  cookies?: Cookies
}


function App(props: Props) {

  const { store, cookies } = props;

  return (
    <div className="App">
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <SnackbarProvider>
            <Suspense fallback={<div/>}>
              <div className="App">
                {/* <header className="App-header">
                  <img src={logo} className="App-logo" alt="logo" />
                  <p>
                    Edit <code>src/App.tsx</code> and save to reload.
                  </p>
                  <a
                    className="App-link"
                    href="https://reactjs.org"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Learn React
                  </a>
                </header> */}
                <Lang>
                  <AppLayout/>
                </Lang>
              </div>
            </Suspense>
            </SnackbarProvider>
          <CookiesConsent/>
        </ThemeProvider>
      </Provider>
    </div>
  );
}

export default App;
